var styles = {"mBreakpointMd":"(min-width: 960px)","page-container":"styles_page-container__3Ys4K flex flex-auto","pageContainer":"styles_page-container__3Ys4K flex flex-auto","content-container":"styles_content-container__2j2Lr max-width-4 mx-auto flex","contentContainer":"styles_content-container__2j2Lr max-width-4 mx-auto flex"};

export default styles;
//# sourceMappingURL=styles.css.js.map
